import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStoreRoomStatus } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchStoreRoomStatus = createAsyncThunk(
  'storeRoomStatus/fetchStoreRoomStatus',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getStoreRoomStatus(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取门店房间状态失败');
    }
  }
) 

const storeRoomStatusSlice = createSlice({
  name: 'storeRoomStatus',
  initialState: defaultState,
  reducers: {
    resetStoreRoomStatusState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStoreRoomStatus.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchStoreRoomStatus.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchStoreRoomStatus.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetStoreRoomStatusState } = storeRoomStatusSlice.actions;
export default storeRoomStatusSlice.reducer;
